import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container, Row, Col, Card, ListGroup, Button, Image, Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./img.css";
import { motion } from "framer-motion";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import Footer from './footer';
import LatestUpdates from "./latestupdates";



const ContentSection = () => (
  <div className="container">
    <h2 className="fw-bold ">Partner Visa</h2>
    <p className="mt-3">
    Consistency and commitment are vital for a partner relationship, 
    and the same attributes are required to lodge and prepare a Partner 
    visa application. Our dedicated team works with you from the beginning to 
    the end until the partner gets PR. Contact us today to lodge your Partner/Spouse visa application
    </p>
    <h3 className="fw-bold ">Apply Overseas – (Subclasses 309 And 100)</h3>
    <p className="mt-3">
    Allows the partner or spouse of an Australian citizen, Australian permanent resident or eligible New Zealand citizen to live in Australia.</p>
    <p className="mt-3"> You apply for the temporary and the permanent partner visas together.  </p>

  </div>
);

const Sidebar = () => (
  <Col md={4}>
   <Col md={12}>
     <div style={{ maxWidth: "800px", width: "100%" }}>
         <Card className="border-0 shadow-none">
         <Card.Header className="fw-bold">Latest Posts</Card.Header>
             <ListGroup variant="flush">
                 <ListGroup.Item className="border-0"><Link to="/professional" className="dropdown-item"> <a href="" className="text-decoration-none">Professional Year</a> </Link></ListGroup.Item>
                 <ListGroup.Item className="border-0"><Link to="/coursechange" className="dropdown-item"> <a href="" className="text-decoration-none">Admissions And Course Change </a></Link></ListGroup.Item>
                 <ListGroup.Item className="border-0"><Link to="/skilledID" className="dropdown-item"> <a href="" className="text-decoration-none">Skilled Independent Visa (Subclass 189)</a></Link></ListGroup.Item>
                 <ListGroup.Item className="border-0"><Link to="/workregionalvisa" className="dropdown-item"> <a href="" className="text-decoration-none">Skilled Work Regional Visa (Subclass 491)</a></Link></ListGroup.Item>
                 <ListGroup.Item className="border-0"><Link to="/nominatedvisa" className="dropdown-item"> <a href="" className="text-decoration-none">Skilled Nominated Visa (Subclass 190)</a></Link></ListGroup.Item>
                  <ListGroup.Item><a href="https://immi.homeaffairs.gov.au/visas/getting-a-visa/visa-listing/skilled-regional-191"className="dropdown-item text-decoration-none"style={{ color: "#22327f" }}target="_blank"rel="noopener noreferrer">Permanent Residence visa (Subclass 191)</a></ListGroup.Item>
                                {/* <ListGroup.Item><Link to="/regionalvisa" className="dropdown-item"><a href="" className="text-decoration-none">Skilled Regional Visa (Subclass 887)</a></Link></ListGroup.Item> */
                                <ListGroup.Item><Link to="/tempactivity" className="dropdown-item"><a href="" className="text-decoration-none">Temporary Activity Visa (Subclass 408)</a></Link></ListGroup.Item>
}
                            </ListGroup>
         </Card>
     </div>
 </Col>
</Col>
);

const VisaPage = () => {
  
  return (
    <div className="container mt-4">
      {/* Apply Section */}
      <div className="row">
        {/* Left Content */}
        <div className="col-md-8">
         
          <h3 className="fw-bold ">Apply In Australia –(Subclasses 820 AND 801)</h3>
          <p>
          Allows the partner or spouse of an Australian citizen, Australian permanent resident
           or eligible New Zealand citizen to live in Australia.
          </p>
          <p>
          You apply for the temporary and the permanent partner visas together.
          </p>
          <h3 className="fw-bold ">Basic Eligibility</h3>
          <p>In most circumstances, you must either be  a relationship with (or) be the spouse (married) or de facto partner of an:</p>
<ul>
    <li>Australian citizen</li>
    <li>Australian permanent resident or</li>
    <li>eligible New Zealand citizen</li>
</ul>
<h3 className="fw-bold ">
Visa Streams</h3>
<VisaTable/>


        </div>

        {/* Right Sidebar */}
        <div className="col-md-4 text-center">
          <img src="./img/brand-logo.png" alt="Bajwa Immigration Consultants" className="img-fluid mb-3" />
          <h5 className="fw-bold">Subscribe to our YouTube channel</h5>
          <button className="btn btn-danger my-2"><a href="https://www.youtube.com/embed/uOGAB9oYets">SUBSCRIBE</a></button>
          <br />
          <button className="btn btn-warning fw-bold my-2">BOOK CONSULTATION</button>

          {/* Social Media Icons */}
          <div className="d-flex justify-content-center gap-2 mt-3">
            <a href="#" className="text-primary fs-4"><i className="bi bi-facebook"></i></a>
            <a href="#" className="text-dark fs-4"><i className="bi bi-tiktok"></i></a>
            <a href="#" className="text-danger fs-4"><i className="bi bi-youtube"></i></a>
            <a href="#" className="text-info fs-4"><i className="bi bi-instagram"></i></a>
          </div>
        </div>
      </div>

      

      {/* Feedback Button */}
      <motion.button
    initial={{ x: "-100vw", opacity: 0 }}
    animate={{ x: 0, opacity: 1 }}
    transition={{ type: "tween", duration: 0.6, ease: "easeOut" }}
    className="btn btn-danger btn-sm position-fixed bottom-0 start-0 m-3"
    style={{ zIndex: 1050 }}
>
    <i className="bi bi-chat-left-text me-1"></i>
    <a 
        href="https://au.bajwaimmigration.com/book-appointment" 
        className="text-white text-decoration-none"
    >
        Consult Now
    </a>
</motion.button>
    </div>
  );
};

const VisaTable = () => {
    return (
        <div className="mt-4 table-responsive">
            <Table bordered hover className="table">
                <thead className="table">
                    <tr>
                        <th>TYPE</th>
                        <th>DESCRIPTION</th>
                        <th>STAY</th>
                        <th>COST</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            <strong>Partner (Provisional)</strong>
                        </td>
                        <td>
                        This visa lets the de facto partner or spouse of an Australian citizen, Australian permanent resident or eligible New Zealand citizen live in Australia temporarily. Getting this visa is the first step towards a permanent Partner visa (subclass 100).
                        </td>
                        <td>Temporarily, until we decide your permanent Partner (Migrant) visa (subclass 100) application or the application is withdrawn</td>
                        <td>From AUD7,715

                           </td>
                    </tr>

                    <tr>
                        <td>
                            <strong>Partner (Migrant)</strong>
                        </td>
                        <td>
                        The visa lets the de facto partner or spouse of an Australian citizen, Australian permanent resident or eligible New Zealand citizen, live in Australia permanently. It is usually granted to people who hold a temporary Partner visa (subclass 309).

                        </td>
                        <td>Permanently</td>
                        <td>You will have paid for this visa when you applied for the combined temporary and permanent partner visas.</td>
                    </tr>
                    <tr>
                        <td>
                            <strong>Partner Visa (Temporary)</strong>
                        </td>
                        <td>
                        This visa lets the de facto partner or spouse of an Australian citizen, Australian permanent resident or eligible New Zealand citizen live in Australia temporarily. Getting this visa is the first step towards a permanent Partner visa (subclass 801).               </td>
                        <td>Temporarily while we process your permanent Partner visa (subclass 801) application or it is withdrawn.</td>
                        <td>From AUD7,715 for most applicants. From AUD1,285 for Prospective Marriage visa (subclass 300) holders.
<br/>
You pay for the temporary and the permanent visa at the same time.

                        </td>
                    </tr>
                    <tr>
                        <td>
                            <strong>Partner Visa (Permanent)</strong>
                        </td>
                        <td>
                        This visa lets the de facto partner or spouse of an Australian citizen, Australian permanent resident or eligible New Zealand citizen live in Australia permanently. It is usually only for people who currently hold a temporary Partner visa (subclass 820).
                        </td>

                        <td>Permanently</td>
                        <td>You paid for this visa when you made your combined application for the  temporary and permanent partner visas.

                        </td>
                    </tr>
                    <tr>
                </tr>
                </tbody>
            </Table>
        </div>
    );
};

const PartnerVisas = () => (
  <>
  <div className="container mt-4">
   
    <div className="row mt-4">
      <div className="col-md-8">
        <ContentSection />
      </div>
      <div className="col-md-4">
        <Sidebar />
      </div>
    </div>
   <VisaPage/>
   
  </div>
  
  <LatestUpdates/>
<Footer/>
</>
);

export default PartnerVisas;